@if (isMediaDisable) {
  <div class="image-upload-lbl">
    @if (currentStep === 'ADD_WAY_POINT_DETAILS') {
      <span>{{commonLables.ADD_MEDIA| translate
      }}</span>
    } @else {
      <span>{{commonLables.ADD_COVER_IMG| translate }}</span>
    }
    @if (markMediaFieldsAsRequired) {
      <span>*</span>
    }
  </div>
}
<div class="media-area-style">
  <div class="upload-media" for="fileField" id="add-media">
    <div class="image-upload">

      <div class="add-img">
        <label for="file-input">
          <span class="upload-icon image-upload-style"></span>
        </label>
        <input #myFileInput id="file-input" type="file" (change)="uploadMediaOnClk($event)"
          (click)="myFileInput.value=''" multiple="multiple" accept=".jpg, .jpeg, .png," />
      </div>
      <ng-container>
        @if ((mediaFiles && mediaFiles.length>0)) {
          <div class="media-container" (click)="showMediaGallery()">
            @for (mediaFile of mediaFiles; track mediaFile; let i = $index) {
              <div class="mediafile"
                [ngClass]="{'remaining-med': i===2 && mediaFilesOverlay && mediaFilesOverlay.length>0}">
                @if ((i===2 && ((mediaFilesOverlay && mediaFilesOverlay.length>0) && showOverlayFlag))) {
                  <span
                    >+
                  {{mediaFilesOverlay.length}}</span>
                }
                <div class="img-tile-item">
                  <img [src]="mediaFile | safe" id="thumbnail-{{i+1}}" alt="'thumbnail'">
                </div>
              </div>
            }
          </div>
        }
      </ng-container>

    </div>
  </div>
</div>